import { LinkIcon, MoreHorizontal, Pencil, Trash2 } from 'lucide-react'

import { Button } from '@/components/lemmala-design-system/button/button'
import {
  DropdownMenu,
  type DropdownMenuActionItem,
  type MenuSeparator,
} from '@/components/lemmala-design-system/dropdown/dropdown-menu'

type CommentActionsMenuProps = {
  canModify: boolean
  onEdit: () => void
  onDelete: () => void
  onCopyLink: () => void
}

export const CommentActionsMenu = ({
  canModify,
  onEdit,
  onDelete,
  onCopyLink,
}: CommentActionsMenuProps) => {
  const menuItems: (DropdownMenuActionItem | MenuSeparator)[] = [
    ...(canModify
      ? [{ content: 'Edit', icon: <Pencil className='size-4' />, onClick: onEdit }]
      : []),
    {
      content: 'Copy comment link',
      icon: <LinkIcon className='size-4' />,
      onClick: onCopyLink,
    },
    ...(canModify
      ? [
          { type: 'menuSeparator' } as const,
          {
            content: 'Delete',
            icon: <Trash2 className='size-4' />,
            onClick: onDelete,
            itemClassName: 'text-main-foreground-danger',
          },
        ]
      : []),
  ]

  return (
    <DropdownMenu
      triggerAppearance='headless'
      triggerContent={
        <Button type='button' variant='ghost-secondary' size='icon-sm' aria-label='Comment actions'>
          <MoreHorizontal className='size-4' />
        </Button>
      }
      menuItems={menuItems}
      variant='custom'
      align='end'
      contentClassName='flex min-w-44 flex-col'
    />
  )
}
